export default __webpack_public_path__ + "static/n2-4e280df360e219e9dca9260d385b0cc4.jpg";